import { render } from "./CookieLaw.vue?vue&type=template&id=78397ac4"
import script from "./CookieLaw.vue?vue&type=script&lang=ts"
export * from "./CookieLaw.vue?vue&type=script&lang=ts"

import "./CookieLaw.vue?vue&type=style&index=0&id=78397ac4&lang=scss"
script.render = render

export default script